import { useState, useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import axios from "../../api/axiosInstance";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import { castIcon } from "../../utils/castIcon";

const MenuIcon = castIcon(HiMenuAlt3);
const CloseIcon = castIcon(HiX);

interface UsageResponse {
    plan: string;
    is_demo?: boolean;
}


export default function SidebarLayout() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [subscriptionPlan, setSubscriptionPlan] = useState<string>("");
    const navigate = useNavigate();
    const [isDemo, setIsDemo] = useState<boolean>(false);

    useEffect(() => {
        const fetchPlan = async () => {
            try {
                const res = await axios.get<UsageResponse>("/bot/request-usage");
                setSubscriptionPlan(res.data.plan);
                setIsDemo(res.data.is_demo || false);
            } catch (err) {
                console.error("Failed to fetch subscription plan:", err);
            }
        };
        fetchPlan();
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        navigate("/login");
    };

    const normalizedPlan = subscriptionPlan.toLowerCase();
    const isProOrEnterprise = normalizedPlan === "pro" || normalizedPlan === "enterprise" || isDemo;
    const isEnterprise = normalizedPlan === "enterprise" || isDemo;

    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {/* Mobile sidebar backdrop */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
                    onClick={() => setIsSidebarOpen(false)}
                ></div>
            )}

            {/* Sidebar */}
            <div
                className={`bg-gray-900 text-white w-full md:w-64 p-6 z-50 md:min-h-screen ${isSidebarOpen ? "block" : "hidden"} md:block`}>
                <div className="flex items-center justify-between px-6 py-4">
                    <h2 className="text-xl font-bold">🍽️ Dashboard</h2>
                    <button onClick={() => setIsSidebarOpen(false)} className="md:hidden text-white">
                        <CloseIcon className="w-6 h-6"/>
                    </button>
                </div>

                <nav className="px-6">
                    <ul className="space-y-4">
                        <li><Link to="/dashboard" className="block py-2 px-3 rounded hover:bg-gray-800">🏠 Home</Link>
                        </li>
                        <li><Link to="/menus" className="block py-2 px-3 rounded hover:bg-gray-800">📜 Manage Menu</Link>
                        </li>
                        <li><Link to="/subscription" className="block py-2 px-3 rounded hover:bg-gray-800">💳
                            Subscription</Link></li>
                        <li><Link to="/chatbot-embed" className="block py-2 px-3 rounded hover:bg-gray-800">💬 Chatbot
                            Embed</Link></li>
                        {isProOrEnterprise && (
                            <li>
                                <Link to="/theme-setup" className="block py-2 px-3 rounded hover:bg-gray-800">
                                    🎨 Theme Setup
                                </Link>
                            </li>
                        )}

                        {/*{normalizedPlan === "enterprise" && (*/}
                        {/*    <li>*/}
                        {/*        <Link to="/analytics" className="block py-2 px-3 rounded hover:bg-gray-800">*/}
                        {/*            📊 Chat Analytics*/}
                        {/*        </Link>*/}
                        {/*    </li>*/}
                        {/*)}*/}

                        {/*{normalizedPlan === "enterprise" && (*/}
                        {/*    <li><Link to="/api-access" className="block py-2 px-3 rounded hover:bg-gray-800">🔐 API Access</Link></li>*/}
                        {/*)}*/}
                        {isEnterprise && (
                            <li>
                                <Link to="/analytics" className="block py-2 px-3 rounded hover:bg-gray-800">
                                    📊 Chat Analytics
                                </Link>
                            </li>
                        )}

                        {isEnterprise && (
                            <li><Link to="/api-access" className="block py-2 px-3 rounded hover:bg-gray-800">🔐 API Access</Link></li>
                        )}
                        <li><Link to="/profile" className="block py-2 px-3 rounded hover:bg-gray-800">⚙️ Profile
                            Settings</Link></li>
                    </ul>
                </nav>

                <div className="px-6">
                    <button onClick={handleLogout}
                            className="w-full mt-6 bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded">
                        🚪 Logout
                    </button>
                </div>
            </div>

            {/* Main Content */}
            <div className="flex-1 p-4 md:p-6">
                <button onClick={() => setIsSidebarOpen(true)}
                        className="md:hidden mb-4 bg-gray-900 text-white px-4 py-2 rounded shadow">
                    <MenuIcon className="w-6 h-6 inline-block"/> <span className="ml-2">Menu</span>
                </button>
                <Outlet/>
            </div>
        </div>
    );
}
